import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmt, fmtD, Tag, Kpi, Btn, Inp, downloadBlob, downloadCsvReport } from "../shared";

export const TicketModal = ({ facture, onClose }) => {
  const now = new Date();
  const num = `FAC-${now.getFullYear()}-${String(facture.id).slice(-4).padStart(4,"0")}`;
  return (
    <div className="ov" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{background:"#fff",borderRadius:16,padding:0,width:340,overflow:"hidden",boxShadow:"0 20px 60px rgba(11,19,51,.25)",animation:"fadeUp .28s cubic-bezier(.22,1,.36,1)"}}>
        {/* Ticket */}
        <div id="ticket-print" style={{background:"#fff",padding:"28px 24px",fontFamily:"'Courier New',monospace"}}>
          <div style={{textAlign:"center",marginBottom:18,paddingBottom:14,borderBottom:"2px dashed #e0e0e0"}}>
            <div style={{display:"flex",justifyContent:"center",marginBottom:8}}><RFLogo size={36}/></div>
            <p style={{fontSize:16,fontWeight:700,fontFamily:"Syne",color:C.navy}}>RésiFlow</p>
            <p style={{fontSize:10,color:C.muted,marginTop:2}}>Gestion de copropriété</p>
          </div>
          <div style={{marginBottom:12,paddingBottom:12,borderBottom:"1px dashed #e0e0e0"}}>
            <p style={{fontSize:11,color:C.muted,textAlign:"center",letterSpacing:"1px"}}>REÇU DE PAIEMENT</p>
            <p style={{fontSize:13,fontWeight:700,color:C.navy,textAlign:"center",marginTop:4}}>{num}</p>
          </div>
          {[
            ["Copropriétaire", facture.resident],
            ["Appartement",    facture.apt],
            ["Description",    facture.type],
            ["Date émission",  fmtD(facture.date)],
            ["Échéance",       fmtD(facture.echeance)],
          ].map(([l,v]) => (
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12}}>
              <span style={{color:C.muted}}>{l}</span>
              <span style={{fontWeight:600,color:C.text,maxWidth:160,textAlign:"right"}}>{v}</span>
            </div>
          ))}
          <div style={{background:C.navy,borderRadius:10,padding:"14px 16px",marginTop:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{color:"rgba(255,255,255,.6)",fontSize:12,fontWeight:600}}>MONTANT TOTAL</span>
            <span style={{color:"#fff",fontSize:20,fontWeight:800,fontFamily:"Syne"}}>{fmt(facture.montant)}</span>
          </div>
          <div style={{textAlign:"center",marginTop:14,paddingTop:12,borderTop:"2px dashed #e0e0e0"}}>
            <div style={{fontSize:32,letterSpacing:4,color:C.navy,fontWeight:800}}>
              ▐▌▐▌▌▐▌▌▐▐▌
            </div>
            <p style={{fontSize:9,color:C.muted,marginTop:4,letterSpacing:"1px"}}>{num} · resiflow.ma</p>
          </div>
        </div>
        {/* Actions */}
        <div style={{display:"flex",gap:0,borderTop:`1px solid ${C.border}`}}>
          <button className="btn" style={{flex:1,padding:"14px",background:"#fff",color:C.text,fontWeight:600,fontSize:13,borderRight:`1px solid ${C.border}`,borderRadius:0}} onClick={() => { try { window.print(); } catch(e) { alert("Impression lancée"); } }}>
            🖨️ Imprimer
          </button>
          <button className="btn" onClick={() => {
            const lines = [`REÇU DE PAIEMENT - ${num}`, ``, `Copropriétaire : ${facture.resident}`, `Appartement    : ${facture.apt}`, `Description    : ${facture.type}`, `Date           : ${fmtD(facture.date)}`, `Echéance       : ${fmtD(facture.echeance)}`, ``, `MONTANT : ${facture.montant} MAD`, ``, `RésiFlow - resiflow.ma`];
            downloadBlob(lines.join("\n"), `recu-${num}.txt`, "text/plain");
          }} style={{flex:1,padding:"14px",background:C.tealL,color:C.teal,fontWeight:600,fontSize:13,borderRadius:0}}>
            📥 Télécharger
          </button>
        </div>
      </div>
    </div>
  );
};

export const FacturationPage = ({ factures, setFactures, residents, immId }) => {
  const list   = factures.filter(f => f.immId === immId);
  const immRes = residents.filter(r => r.immId === immId);
  const [modal,  setModal]  = useState(false);
  const [ticket, setTicket] = useState(null);
  const [form,   setForm]   = useState({residentId:"",montant:"",type:"Charges courantes Q1"});

  const save = () => {
    const r = immRes.find(x => x.id === Number(form.residentId));
    if (!r) return;
    const today = new Date().toISOString().slice(0,10);
    const newF = {id:Date.now(), immId, residentId:r.id, resident:`${r.nom} ${r.prenom}`, apt:r.apt, montant:Number(form.montant), date:today, echeance:today, statut:"impayé", type:form.type};
    setFactures(p => [...p, newF]);
    setModal(false);
    setTicket(newF);
  };

  const totalPaye = list.filter(f=>f.statut==="payé").reduce((a,f)=>a+f.montant,0);
  const totalDu   = list.filter(f=>f.statut!=="payé").reduce((a,f)=>a+f.montant,0);

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Facturation</h2>
          <p style={{color:C.muted,fontSize:13}}>{list.length} factures · {fmt(totalPaye)} encaissé</p>
        </div>
        <div style={{display:"flex",gap:10}}>
          <button className="btn" onClick={() => downloadCsvReport(`factures-${immId}.csv`, [["N°","Résident","Apt","Type","Date","Montant","Statut"],...list.map(f=>[`FAC-${String(f.id).slice(-4)}`,f.resident,f.apt,f.type,fmtD(f.date),f.montant,f.statut])])}
            style={{padding:"9px 16px",borderRadius:10,background:C.blueL,color:C.blue,fontWeight:600,fontSize:13}}>
            📊 Export CSV
          </button>
          <Btn onClick={() => setModal(true)}>+ Nouvelle facture</Btn>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
        <Kpi icon="🧾" label="Factures émises"  value={list.length}    color={C.blue}  delay={0} />
        <Kpi icon="✅" label="Total encaissé"    value={fmt(totalPaye)} color={C.green} delay={60} />
        <Kpi icon="⏳" label="En attente"        value={fmt(totalDu)}   color={C.gold}  delay={120} />
      </div>

      <div className="fu" style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
        <table>
          <thead><tr><th>N° Facture</th><th>Copropriétaire</th><th>Apt.</th><th>Description</th><th>Date</th><th>Montant</th><th>Statut</th><th>Actions</th></tr></thead>
          <tbody>
            {list.map(f => (
              <tr key={f.id}>
                <td style={{fontWeight:700,color:C.blue}}>FAC-{String(f.id).slice(-4).padStart(4,"0")}</td>
                <td style={{fontWeight:600}}>{f.resident}</td>
                <td><span style={{background:C.blueL,color:C.blue,padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{f.apt}</span></td>
                <td style={{color:C.muted}}>{f.type}</td>
                <td style={{color:C.muted}}>{fmtD(f.date)}</td>
                <td style={{fontWeight:700}}>{fmt(f.montant)}</td>
                <td><Tag s={f.statut} /></td>
                <td>
                  <div style={{display:"flex",gap:5}}>
                    <button className="btn" onClick={() => setTicket(f)}
                      style={{padding:"4px 9px",background:"#f5f3ff",color:C.purple,borderRadius:7,fontWeight:600,fontSize:11}}>
                      🧾 Reçu
                    </button>
                    <button className="btn" onClick={() => alert(`📤 Facture envoyée à ${f.resident} !`)}
                      style={{padding:"4px 9px",background:C.tealL,color:C.teal,borderRadius:7,fontWeight:600,fontSize:11}}>
                      📤 Email
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {ticket && <TicketModal facture={ticket} onClose={() => setTicket(null)} />}

      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Nouvelle facture</h3>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase"}}>Copropriétaire</label>
              <select value={form.residentId} onChange={e => setForm({...form,residentId:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:"DM Sans",background:"#fff"}}>
                <option value="">— Sélectionner —</option>
                {immRes.map(r => <option key={r.id} value={r.id}>{r.prenom} {r.nom} ({r.apt})</option>)}
              </select>
            </div>
            <Inp label="Montant (MAD)" type="number" value={form.montant} onChange={v => setForm({...form,montant:v})} />
            <Inp label="Description" value={form.type} onChange={v => setForm({...form,type:v})} />
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Créer & Générer reçu</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — CHARGES
══════════════════════════════════════ */
